import Service from '@/service'
export default {
    computed: {
        show_visit_reservation () {
            return this.house.activities && this.house.activities.indexOf('visit_reservation') > -1
        },
        visit_reservation_url () {
            const { id, name, my_visit_reservation_status } = this.house
            if (my_visit_reservation_status === '已预约') {
                return `/personal_package/visit_reservation/main?building_id=${id}`
            }
            return `/activity_a/building_visit_reservations/main?building_id=${id}&building_name=${name}`
        },
        visit_reservation_tip () {
            const { visit_reservation_tip } = this.house
            const tips = visit_reservation_tip ? visit_reservation_tip.split('，') : []
            if (tips.length) {
                return tips.join(' ')
            }
            return ''
        }
    },
    onReady () {
        if (this.$route.query.type === 'visit_reservation') {
            this.checkVisitReservation()
        }
    },
    methods: {
        checkVisitReservation () {
            const { building_id } = this.$route.query
            Service.getBuilding(building_id).then(data => {
                if (data.my_visit_reservation_status === '已预约') {
                    wx.navigateTo({
                        url: `/pages/personal_package/visit_reservation/main?building_id=${building_id}`
                    })
                } else {
                    wx.navigateTo({
                        url: `/pages/activity_a/building_visit_reservations/main?building_id=${building_id}&building_name=${data.name}`
                    })
                }
            })
        }
    }
}